module.exports = __webpack_public_path__ + "img/icon-cvv.930d0200.png";